<template>
  <LocaleProviderx>
    <div
      id="app"
      @drop="drop"
    >
      <RouterView />
      <div
        v-if="$store.state.app.loading"
        class="loading-spin"
      >
        <a-spin size="large" />
      </div>
    </div>
  </LocaleProviderx>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  mounted () {
    // console.log('BASE_URL', process.env.BASE_URL)
    this.$store.commit('app/refreshScreenSize')

    window.addEventListener('resize', () => {
      this.$store.commit('app/refreshScreenSize')
    })

    if (this.$conf.aliveKeep > 0) {
      this.checkAlive()
    }
  },
  methods: {
    checkAlive () {
      this.$store.commit('app/updateAliveTime')

      window.addEventListener('click', () => {
        this.$store.commit('app/updateAliveTime')
      })

      window.setInterval(() => {
        if (new Date().getTime() > this.$store.state.app.aliveTime + this.$conf.aliveKeep * 1000) {
          if (this.$route.name !== 'Login') {
            this.logout()
          }
        }
      }, 3000)
    },
    logout () {
      window.localStorage.removeItem('token')
      this.$router.push({ name: this.$conf.loginRouter })
    },
    drop ($event) {
      $event.preventDefault()
      $event.stopPropagation()
    }
  }
}
</script>

<style scoped>
  .loading-spin {
    background-color: rgba(0, 0, 0, 0.65);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 1005;
  }

  .loading-spin >>> .ant-spin {
    position: fixed;
    top: calc(50% - 16px);
    left: calc(50% - 16px);
  }
</style>

<style lang="less">
  .size {
    width: 100%;
    height: 100%;
  }

  html, body {
    .size;
    margin: 0;
    padding: 0;
    word-break: break-all;
    word-wrap: break-word;
  }

  #app {
    .size;
  }
</style>
